var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCloseOverlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 20,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2 12c0-5.51364 4.48636-10 10-10 5.5136 0 10 4.48636 10 10 0 5.5136-4.4864 10-10 10-5.51364 0-10-4.4864-10-10zm13.9591 3.9591c.1773-.1773.1773-.4682 0-.6455l-3.3136-3.3136 3.3136-3.31364c.1773-.17727.1773-.46818 0-.64545s-.4682-.17727-.6455 0l-3.3136 3.31359-3.31364-3.31359c-.17727-.17727-.46818-.17727-.64545 0s-.17727.46818 0 .64545l3.31359 3.31364-3.31359 3.3136c-.17727.1773-.17727.4682 0 .6455.09091.0864.20454.1318.32273.1318.11818 0 .23181-.0454.32272-.1318l3.31364-3.3136 3.3136 3.3136c.0909.0864.2046.1318.3228.1318.1181 0 .2318-.0454.3227-.1318z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 24c6.6274 0 12-5.3726 12-12 0-6.62742-5.3726-12-12-12-6.62742 0-12 5.37258-12 12 0 6.6274 5.37258 12 12 12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 12c0-5.51364 4.48636-10 10-10 5.5136 0 10 4.48636 10 10 0 5.5136-4.4864 10-10 10-5.51364 0-10-4.4864-10-10zm13.9591 3.9591c.1773-.1773.1773-.4682 0-.6455l-3.3136-3.3136 3.3136-3.31364c.1773-.17727.1773-.46818 0-.64545s-.4682-.17727-.6455 0l-3.3136 3.31359-3.31364-3.31359c-.17727-.17727-.46818-.17727-.64545 0s-.17727.46818 0 .64545l3.31359 3.31364-3.31359 3.3136c-.17727.1773-.17727.4682 0 .6455.09091.0864.20454.1318.32273.1318.11818 0 .23181-.0454.32272-.1318l3.31364-3.3136 3.3136 3.3136c.0909.0864.2046.1318.3228.1318.1181 0 .2318-.0454.3227-.1318z",
    fill: "#5d6677"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseOverlay);
export default __webpack_public_path__ + "static/media/ico_close_overlay.6cc2614bdfc533beba7c6d3df02c23b1.svg";
export { ForwardRef as ReactComponent };